<app-modal [title]="title" (closed)="reject()" #modal>

  <div class="submit-section text-center row mt-3" [innerHtml]="subject"></div>

  <!-- Message d'erreur global rouge -->
  <div *ngIf="globalError" class="alert alert-danger mx-3 mt-3 mb-0 py-2 text-center">
    <i class="fas fa-exclamation-circle me-1"></i>
    {{ globalError }}
  </div>

  <div class="mt-4 px-3">

    <div class="mb-3" *ngFor="let field of fields">

      <label class="form-label fw-bold">
        {{ field.label }}
        <span *ngIf="field.required" class="text-danger">*</span>
      </label>

      <input
        [type]="field.type || 'text'"
        class="form-control"
        [ngClass]="{ 'is-invalid': field.error }"
        [(ngModel)]="field.value"
        (ngModelChange)="onFieldChange()"
      />

      <div *ngIf="field.error" class="invalid-feedback d-block">
        {{ field.error }}
      </div>

    </div>

    <div class="submit-section text-center row mt-4" style="width: 40%; margin-left: 30%;">

      <div class="col-lg-6">
        <button
          class="btn btn-primary submit-btn w-100"
          (click)="accept()"
          [disabled]="!hasAtLeastOneFilled"
        >
          OK
        </button>
      </div>

      <div class="col-lg-6">
        <button
          class="btn btn-danger submit-btn w-100"
          (click)="reject()"
        >
          Annuler
        </button>
      </div>

    </div>

  </div>

</app-modal>